import React from 'react';

import couture from './img/art-pt3-level-up.jpg';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';
import ModalImage    from '../../modal-image';
import Paras         from '../../paras';
import Screenshot    from '../../screenshot';

import * as css from './index.module.css';

const prefix = 'part3.ys';

const colors = [ 'black', 'blue', 'green' ];

export default function YourStory() {
    const equipment = Object.keys(i18n(`${prefix}.gp.list`, { md : false }));

    return <>
        <SectionHeader name="your-story" />

        <div className='section'>
            <p className={css.para0}>{i18n(`${prefix}.para.0`)}</p>

            <div className={css.cols}>
                <div className={css.col0}>
                    <div className={css.lu}>
                        <h3>{i18n(`${prefix}.lu.header`)}</h3>
                        <Paras path={`${prefix}.lu.para`}/>
                    </div>

                    <div className={css.eq}>
                        <h3>{i18n(`${prefix}.eq.header`)}</h3>
                        <Paras path={`${prefix}.eq.para`}/>
                    </div>
                </div>

                <div className={css.couture}>
                    <img src={couture} />
                </div>
            </div>
            <div>
                <h4 className={css.gpHeader}>{i18n(`${prefix}.gp.header`)}</h4>

                <ul className={css.gpList}>
                    {equipment.map((key, idx) => (
                        <li key={key} className={css.gpItem}>
                            <ModalImage path={`${prefix}.gp.list.${key}.modal`}>
                                <Screenshot path={`${prefix}.gp.list.${key}.img`} theme={colors[idx]} />
                            </ModalImage>

                            <p>{i18n(`${prefix}.gp.list.${key}.title`)}</p>
                            <p className={css.defense}>{i18n(`${prefix}.gp.list.${key}.defense`)}</p>
                        </li>
                    ))}
                </ul>
            </div>

        </div>
    </>;
}

